import React from 'react'
import { Route, Redirect } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'

const PageLayout              = Loadable({ loader: () => import('layers/lsc-schedules/containers/PageLayout/PageLayout'), loading})

const ListBusesPage           = Loadable({ loader: () => import('layers/lsc-schedules/pages/ListBusesPage/ListBusesPage'), loading })
const ListConductorsPage      = Loadable({ loader: () => import('layers/lsc-schedules/pages/ListConductorsPage/ListConductorsPage'), loading })
const ListDriversPage         = Loadable({ loader: () => import('layers/lsc-schedules/pages/ListDriversPage/ListDriversPage'), loading })
const ListRoutesPage          = Loadable({ loader: () => import('layers/lsc-schedules/pages/ListRoutesPage/ListRoutesPage'), loading })

const PrintPage               = Loadable({ loader: () => import('layers/lsc-schedules/pages/PrintPage/PrintPage'), loading })
const PsrPage                 = Loadable({ loader: () => import('layers/lsc-schedules/pages/PsrPage/PsrPage'), loading })

const ScheduleBusPage         = Loadable({ loader: () => import('layers/lsc-schedules/pages/ScheduleBusPage/ScheduleBusPage'), loading })
const ScheduleConductorsPage  = Loadable({ loader: () => import('layers/lsc-schedules/pages/ScheduleConductorsPage/ScheduleConductorsPage'), loading })
const ScheduleDriversPage     = Loadable({ loader: () => import('layers/lsc-schedules/pages/ScheduleDriversPage/ScheduleDriversPage'), loading })
const ScheduleOrderPage       = Loadable({ loader: () => import('layers/lsc-schedules/pages/ScheduleOrdersPage/ScheduleOrdersPage'), loading })
const ScheduleOrderOldPage    = Loadable({ loader: () => import('layers/lsc-schedules/pages/ScheduleOrdersOldPage/ScheduleOrdersOldPage'), loading })


export default (links) => (
  <Route>
    <Route component={PageLayout}>
      <Route path={links.root} component={PsrPage} />
      <Route path={links.drivers.root} component={ListDriversPage} />
      <Route path={links.drivers.schedule} component={ScheduleDriversPage} />

      <Route path={links.conductors.root} component={ListConductorsPage} />
      <Route path={links.conductors.schedule} component={ScheduleConductorsPage} />

      <Route path={links.buses.root} component={ListBusesPage} />
      <Route path={links.buses.schedule} component={ScheduleBusPage} />

      <Route path={links.routes} component={ListRoutesPage} />

      <Route path={links.schedule.root} component={ScheduleOrderPage} />
      <Route path={links.schedule.old} component={ScheduleOrderOldPage} />

      <Route path={links.schedule.print} component={PrintPage} />

      <Redirect path={`${links.root}/*`} to={links.root} />
    </Route>
  </Route>
)
